module.exports = __webpack_public_path__ + "img/android_browser_tips.a08df5fb.png";